import React from "react";
import { Link } from "react-router-dom";

export default function AdminBookingCard(props) {
  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 mb-md-4 mb-5 single-booking px-2">
        <div className="inner-cover">
          <div
            className="image-side"
            style={{ background: `url(${props.img})` }}
          ></div>
          <div className="details-side mt-3">
            {/* Booking Details Start */}
            <h4 className="mb-4">Booking Details</h4>
            <p className="mb-0">
              <span>Name:</span> {props.bookingHolderName}
            </p>
            <p className="mb-0">
              <span>Booking Id:</span> {props.bookingId}
            </p>
            <p className="mb-0">
              <span>From:</span> {props.fromDate.split("T")[0]}
            </p>
            <p className="mb-0">
              <span>To:</span> {props.toDate.split("T")[0]}
            </p>
            <p className="mb-0">
              <span>Hotel:</span> {props.hotelName}
            </p>
            <p className="mb-0">
              <span>Room:</span> {props.room}
            </p>
            <p className="mb-0">
              <span>Rent Per Day:</span> ${props.rentPerDay}
            </p>
            <p className="mb-0">
              <span>Total Amount:</span> ${props.totalAmount}
            </p>
            <p className="mb-0">
              <span>Status:&nbsp;&nbsp;</span>{" "}
              <span
                className={`custom-badge custom-booking-badge mb-2 ${
                  props.bookingStatus === "Pending" && "pending-badge"
                } ${props.bookingStatus === "Active" && "active-badge"} ${
                  props.bookingStatus === "Cancelled" && "cancel-badge"
                } ${props.bookingStatus === "Expired" && "expire-badge"}`}
              >
                {props.bookingStatus}
              </span>
            </p>
            {/* Booking Details End */}

            {/* Button */}
            {props.bookingStatus === "Pending" && (
              <Link
                className="btn pay-btn custom-btn rounded-pill text-decoration-none"
                to={`/admin/edit-booking/${props.bookingIdForUpdate}`}
              >
                Update
              </Link>
            )}
            {props.bookingStatus === "Active" && (
              <Link
                className="btn pay-btn custom-btn rounded-pill text-decoration-none"
                to={`/admin/edit-booking/${props.bookingIdForUpdate}`}
              >
                Update
              </Link>
            )}
            {props.bookingStatus === "Cancelled" && (
              <button className="btn pay-btn custom-btn rounded-pill" disabled>
                Cancelled
              </button>
            )}
            {props.bookingStatus === "Expired" && (
              <button className="btn pay-btn custom-btn rounded-pill" disabled>
                Expired
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
